export const columnDefs = [
    {
        headerName: 'Images',
        field: 'images',
        minWidth: 100,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Project Name',
        field: 'name',
        minWidth: 120,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Project Number',
        field: 'project_no',
        minWidth: 140,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Project Type',
        field: 'type',
        minWidth: 120,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Project Status',
        field: 'status',
        minWidth: 122,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: '# Of Rooms',
        field: 'room_count',
        minWidth: 110,
        filter: false,
        hide: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Creation Date',
        field: 'created_at',
        minWidth: 122,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Occupancy Date',
        field: 'target_occupation',
        minWidth: 140,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Current Phase',
        field: 'current_phase',
        minWidth: 220,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
        {
        headerName: 'Project Owner',
        field: 'owner',
        minWidth: 70,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Team',
        field: 'teamid',
        minWidth: 70,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Client Organization / Account',
        field: 'client_organization',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: '# of Departments',
        field: 'department_count',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Combined # of Rooms',
        field: 'combined_room_count',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Inactive # of Rooms',
        field: 'inactive_room_count',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Created By',
        field: 'created_by',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Funding Source',
        field: 'funding_source',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Total Construction Cost',
        field: 'total_construction_cost',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Total Approved Budget',
        field: 'total_approved_budget',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Total Project Budget',
        field: 'total_project_budget',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Total Project Variance',
        field: 'project_variance',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Project Tax',
        field: 'total_tax',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Freight',
        field: 'taxable_option',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Fees',
        field: 'taxable_option_1',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
        colId: 'taxable_option_1'
    },
    {
        headerName: 'Installation',
        field: 'taxable_option_2',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
        colId: 'taxable_option_2'
    },
    {
        headerName: 'Storage',
        field: 'taxable_option_3',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
        colId: 'taxable_option_3'
    },
    {
        headerName: 'Project Sub Total',
        field: 'sub_total',
        minWidth: 150,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Tax Exempt',
        field: 'is_tax_exempt',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true
    },
    {
        headerName: 'City',
        field: 'city',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true
    },
    {
        headerName: 'State',
        field: 'state',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true
    },
    {
        headerName: 'Country',
        field: 'country',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true
    },
];

export const BuildingColDefs = [
    {
        field: '',
        checkboxSelection: true,
        resizable: false,
        sortable: false,
        width: 50
    },
    {
        headerName: 'BuildingId',
        field: 'building_id',
        hide: true,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 110,
        flex: 1,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Building Name',
        field: 'building_name',
        minWidth: 120,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Building ID',
        field: 'building_no',
        minWidth: 120,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Building Type',
        field: 'type',
        minWidth: 120,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Building Total',
        field: 'total_cost',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Building Sub Total',
        field: 'subtotal',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Building Total Area',
        field: 'total_area',
        minWidth: 165,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: '# Of Rooms',
        field: 'total_rooms',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: '# Of InActive Rooms',
        field: 'total_inactive_rooms',
        minWidth: 120,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: '# Of Combined Rooms',
        field: 'total_combind_rooms',
        minWidth: 120,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: '# Of Levels',
        field: 'total_level',
        minWidth: 100,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: '# Of InActive Levels',
        field: 'total_inactive_level',
        minWidth: 120,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'State',
        field: 'status',
        minWidth: 100,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Notes',
        field: 'notes',
        minWidth: 122,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
];

export const LevelColDefs = [
    {
        field: '',
        checkboxSelection: true,
        resizable: false,
        sortable: false,
        width: 50
    },
    {
        headerName: 'LevelId',
        field: 'level_id',
        hide: true,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 110,
        flex: 1,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Level Name',
        field: 'level_name',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Level ID',
        field: 'level_no',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Building',
        field: 'building_name',
        minWidth: 130,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Level Total',
        field: 'total_cost',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Level Sub Total',
        field: 'subtotal',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Level Total Area',
        field: 'total_area',
        minWidth: 165,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: '# Of Rooms',
        field: 'total_rooms',
        minWidth: 90,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: '# Of InActive Rooms',
        field: 'total_inactive_rooms',
        minWidth: 90,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: '# Of Combined Rooms',
        field: 'total_combind_rooms',
        minWidth: 90,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'State',
        field: 'status',
        minWidth: 80,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Notes',
        field: 'notes',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
];

export const DepartColDefs = [
    {
        field: '',
        checkboxSelection: true,
        resizable: false,
        sortable: false,
        width: 50
    },
    {
        headerName: 'DepId',
        field: 'department_id',
        hide: true,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 110,
        flex: 1,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Department Name',
        field: 'department_name',
        minWidth: 145,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Department ID',
        field: 'department_no',
        minWidth: 140,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Department Type',
        field: 'type',
        minWidth: 130,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Level',
        field: 'level',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Building',
        field: 'building',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Department Total',
        field: 'total_cost',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Department Sub Total',
        field: 'subtotal',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Dep Total Area',
        field: 'total_area',
        minWidth: 165,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: '# Of Rooms',
        field: 'total_rooms',
        minWidth: 90,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: '# Of InActive Rooms',
        field: 'total_inactive_rooms',
        minWidth: 90,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: '# Of Combined Rooms',
        field: 'total_combind_rooms',
        minWidth: 90,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Area/Phase Name',
        field: 'phase_name',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Area/Phase Date',
        field: 'phase_date',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Cost Centre',
        field: 'cost_centre',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'State',
        field: 'status',
        minWidth: 80,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Notes',
        field: 'notes',
        minWidth: 100,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
];

export const ActivityColDefs = [
    {
        headerName: 'Action',
        field: '',
        flex: 1,
        minWidth: 70,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Object Type',
        field: 'table_name',
        minWidth: 150,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Object Name',
        field: 'object_name',
        flex: 1,
        minWidth: 215,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Action Performed',
        field: 'action',
        flex: 1,
        minWidth: 215,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Transaction ID',
        field: 'audit_id',
        flex: 1,
        minWidth: 215,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Activity By',
        field: 'user',
        flex: 1,
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Activity Date',
        field: 'created_at',
        flex: 1,
        minWidth: 170,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
];

export const RoomColDefs = [
    {
        field: '',
        checkboxSelection: true,
        resizable: false,
        sortable: false,
        width: 50
    },
    {
        headerName: 'RoomId',
        field: 'room_id',
        hide: true,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 110,
        flex: 1,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Room Name',
        field: 'room_name',
        minWidth: 140,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Room QTY',
        field: 'quantity',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Room No',
        field: 'room_no',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Department',
        field: 'department',
        minWidth: 160,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Item QTY',
        field: 'item_quantity',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Total Extended QTY',
        field: 'extended_qty',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Room Sub Total',
        field: 'subtotal',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Room Total',
        field: 'room_total',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Total Extended Cost',
        field: 'extended_cost',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Room Area',
        field: 'room_area',
        minWidth: 165,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Total Room Area',
        field: 'total_area',
        minWidth: 170,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Need By',
        field: 'need_by',
        minWidth: 110,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'State',
        field: 'status',
        minWidth: 80,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Notes',
        field: 'notes',
        minWidth: 100,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Room Tag',
        field: 'tags',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Room Signage',
        field: 'room_signage',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Level',
        field: 'level',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Building',
        field: 'building',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Area/Phase Name',
        field: 'phase_name',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Area/Phase Date',
        field: 'phase_date',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Cost Centre',
        field: 'cost_centre_name',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'InActive Item QTY',
        field: 'inactive_item_qty',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
    },
    {
        headerName: 'Budget Name',
        field: 'budget_name',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Budget Type',
        field: 'budget_type',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Budget ID',
        field: 'budget_no',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Expanse Code',
        field: 'expanse_code',
        minWidth: 110,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
];

export const UpdateRoomDef = [
    {
        headerName: 'RoomId',
        field: 'room_id',
        hide: true,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Room Name',
        field: 'room_name',
        minWidth: 250,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        editable: true,
        cellStyle: (params) => {
            return {
                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                border: 'none',
            }
        },
    },
    {
        headerName: 'Room QTY',
        field: 'quantity',
        minWidth: 130,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        editable: true,
        cellStyle: (params) => {
            return {
                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                border: 'none',
            }
        },
    },
    {
        headerName: 'Room ID',
        field: 'room_no',
        minWidth: 250,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        editable: true,
        cellStyle: (params) => {
            return {
                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                border: 'none',
            }
        },
    },
    {
        headerName: 'Room Area',
        field: 'room_area',
        minWidth: 240,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        editable: true,
        cellStyle: (params) => {
            return {
                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                border: 'none',
            }
        },
    },
    {
        headerName: 'Room Tag',
        field: 'tags',
        minWidth: 240,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        editable: true,
        cellStyle: (params) => {
            return {
                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                border: 'none',
            }
        },
    },
    {
        headerName: 'Room Signage',
        field: 'room_signage',
        minWidth: 240,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        editable: true,
        cellStyle: (params) => {
            return {
                background: params.node.rowIndex % 2 === 0 ? 'white' : 'lightgray',
                border: 'none',
            }
        },
    },
];

export const ItemColDefs = [
    {
        field: '',
        checkboxSelection: true,
        resizable: false,
        sortable: false,
        minWidth: 50,
        flex: 1
    },
    {
        headerName: 'ItemId',
        field: 'item_id',
        hide: true,
        filter: false,
        resizable: true,
    },
    {
        headerName: 'Actions',
        field: 'action',
        minWidth: 90,
        flex: 1,
        filter: false,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'ProductId',
        field: 'product_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Images',
        field: 'images',
        minWidth: 75,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Description',
        field: 'category_name',
        minWidth: 200,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Numeric ID',
        field: 'sku_no',
        minWidth: 220,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Model',
        field: 'model',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Manufacturer',
        field: 'manufacturer',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Item QTY',
        field: 'quantity',
        minWidth: 70,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Unit Cost',
        field: 'unit_price',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Sub Total',
        field: 'totalcost',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Total Cost',
        field: 'finaltotal',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Category',
        field: 'category',
        minWidth: 100,
        hide: false,
        filter: false,
        resizable: true
    },
    {
        headerName: 'Subcategory',
        field: 'sub_category',
        minWidth: 150,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true
    },
    {
        headerName: 'Architectural Code',
        field: 'architectural_code',
        minWidth: 180,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Status',
        field: 'status',
        minWidth: 180,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Action Stage',
        field: 'stage',
        minWidth: 180,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true
    },
    {
        headerName: 'Room QTY',
        field: 'room_quantity',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Total Extended Room-Item QTY',
        field: 'extended_item_quantity',
        minWidth: 250,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Room Sub Total',
        field: 'room_sub_total',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Total Extended Cost',
        field: 'total_extended_cost',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Room',
        field: 'room_name',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Room #',
        field: 'room_no',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Department',
        field: 'department_name',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Level',
        field: 'level_name',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Building',
        field: 'building_name',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Area/Phase Name',
        field: 'phase',
        minWidth: 135,
        hide: true,
        flex: 1,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Area/Phase Date',
        field: 'phase_date',
        flex: 1,
        minWidth: 125,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Cost Centre',
        field: 'cost_centre',
        minWidth: 100,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Alphanumeric ID',
        field: 'prefix',
        minWidth: 270,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Alternate Description',
        field: 'alternate_description',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Item Notes',
        field: 'notes',
        minWidth: 120,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Scope',
        field: 'scope',
        minWidth: 100,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },

    {
        headerName: 'Custom ID 1',
        field: 'custom_id_1',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Custom ID 2',
        field: 'custom_id_2',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Inventory ID',
        field: 'inventory_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Alternate ID',
        field: 'alternate_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Govt. D',
        field: 'govt_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Vendor',
        field: 'vendor',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Action Stage Date',
        field: 'stage_date',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Long Description',
        field: 'description',
        minWidth: 300,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Price Type',
        field: 'price_type',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Funding Source',
        field: 'funding_source',
        minWidth: 150,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Freight',
        field: 'freight',
        minWidth: 150,
        hide: true,
        flex: 1,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Fees',
        field: 'fees',
        minWidth: 150,
        hide: true,
        flex: 1,
        filter: false,
        resizable: true,
        suppressMenu: true,
        colId: 'taxable_option_1'
    },
    {
        headerName: 'Installation',
        field: 'installation',
        minWidth: 150,
        hide: true,
        flex: 1,
        filter: false,
        resizable: true,
        suppressMenu: true,
        colId: 'taxable_option_2'
    },
    {
        headerName: 'Storage',
        field: 'storage',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
        colId: 'taxable_option_3'
    },
    {
        headerName: 'Discount',
        field: 'discount',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
        flex: 1,
    },
    {
        headerName: 'Trade-In',
        field: 'trade_in',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
        flex: 1,
    },
    {
        headerName: 'Budget',
        field: 'budget',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
        flex: 1,
    },
    {
        headerName: 'Tax',
        field: 'tax_number',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
        flex: 1,
    },
    {
        headerName: 'Tax Rate',
        field: 'tax',
        minWidth: 150,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
        flex: 1,
    },
    {
        headerName: 'Additional Tax',
        field: 'additional_tax',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Sub Total Tax',
        field: 'sub_total_tax',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Total Tax',
        field: 'total_tax',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Product Type',
        field: 'product_type',
        minWidth: 150,
        hide: true,
        flex: 1,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Life Expectancy / Lifespan',
        field: 'life_expectancy',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Lead Time',
        field: 'lead_time',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Furnish Responsibility',
        field: 'furnish_responsibility',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Install Responsibility',
        field: 'install_responsibility',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Architecturally Significant',
        field: 'architecturally_significant',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Spatially Significant',
        field: 'spatially_significant',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Width',
        field: 'minWidth',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Height',
        field: 'height',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Depth',
        field: 'depth',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Clearance - Left',
        field: 'clearance',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-left'
    },
    {
        headerName: 'Clearance - Right',
        field: 'clearance_right',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-right'
    },
    {
        headerName: 'Clearance - Back',
        field: 'clearance_back',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-back'
    },
    {
        headerName: 'Clearance - Front',
        field: 'clearance_front',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-front'
    },
    {
        headerName: 'Clearance - Top',
        field: 'clearance_top',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-top'
    },
    {
        headerName: 'Clearance - Bottom',
        field: 'clearance_bottom',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-bottom'
    },
    {
        headerName: 'Mouting',
        field: 'mouting',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Max Weight',
        field: 'max_weight',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Ship Weight',
        field: 'ship_weight',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Operating Weight',
        field: 'operating_weight',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'DA Complient',
        field: 'da_complient',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Antimicrobial',
        field: 'antimicrobial',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Green',
        field: 'green',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Shielding',
        field: 'Shielding',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Seismic',
        field: 'seismic',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Voltage Type',
        field: 'electrical_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'voltage_type'
    },
    {
        headerName: 'Volts',
        field: 'volts',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'volts'
    },
    {
        headerName: 'Amps',
        field: 'amps',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'amps'
    },
    {
        headerName: 'Watts',
        field: 'watts',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'watts'
    },
    {
        headerName: 'kVA',
        field: 'kva',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'kva'
    },
    {
        headerName: 'Hertz',
        field: 'hertz',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'hertz'
    },
    {
        headerName: 'Electric Phase',
        field: 'electric_phase',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'electric_phase'
    },
    {
        headerName: 'Plug Type',
        field: 'plug_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'plug_type'
    },
    {
        headerName: 'Plug Details',
        field: 'plug_details',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'plug_details'
    },
    {
        headerName: 'Emergency Power',
        field: 'emergency_power',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'emergency_power'
    },
    {
        headerName: 'Remote Transformer',
        field: 'remote_transformer',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'remote_transformer'
    },
    {
        headerName: 'Remote Switch / Controller',
        field: 'remote_switch',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'remote_switch'
    },
    {
        headerName: 'Tech Connection',
        field: 'tech_connection_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'tech_connection'
    },
    {
        headerName: 'Connection Type',
        field: 'connection_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'connection_type'
    },
    {
        headerName: 'Network',
        field: 'network',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'network'
    },
    {
        headerName: 'Water Cold',
        field: 'plumbing_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'cold'
    },
    {
        headerName: 'Water Hot',
        field: 'hot',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'hot'
    },
    {
        headerName: 'Water Treated',
        field: 'treated',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'treated'
    },
    {
        headerName: 'Steam',
        field: 'steam',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'steam'
    },
    {
        headerName: 'Medical Vaccum',
        field: 'medical_vaccum',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'medical_vaccum'
    },
    {
        headerName: 'Dental Vaccum',
        field: 'dental_vaccum',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'dental_vaccum',
        cellRenderer: (params) => {
            if (params?.data) {
                return (
                    <span>{params?.data?.plumbing_data?.vaccumDental ? 'Yes' : 'No'}</span>
                );
            }
            return '';
        },
    },
    {
        headerName: 'Medical Gas',
        field: 'medical_gas',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'medical_gas'
    },
    {
        headerName: 'Drain',
        field: 'drain',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'drain'
    },
    {
        headerName: 'Drain Location',
        field: 'drain_location',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'drain_location'
    },
    {
        headerName: 'Gas Type',
        field: 'gas_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'gas_type'
    },
    {
        headerName: 'Gas Location',
        field: 'gas_location',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'gas_location'
    },
    {
        headerName: 'Vent',
        field: 'mechanical_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'vent'
    },
    {
        headerName: 'Vent Type',
        field: 'vent_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'vent_type'
    },
    {
        headerName: 'Heat Dissipation (BTU/hr)',
        field: 'heat_hr',
        minWidth: 200,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'heat_hr'
    },
    {
        headerName: 'Dissipation Type',
        field: 'dissipation_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'dissipation_type'
    },
    {
        headerName: 'PO',
        field: 'po',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'Requisition',
        field: 'requisition',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'Bid',
        field: 'bid',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'RFQ',
        field: 'rfq',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
]

export const ProcurementColDefs = [
    {
        headerName: 'PA ID',
        field: 'pa_id',
        minWidth: 100,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'Requisition #',
        field: 'requisition_no',
        minWidth: 120,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'Requisition Status',
        field: 'requisition_status',
        minWidth: 120,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'Bid #',
        field: 'bidding_no',
        minWidth: 120,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'Bid Status',
        field: 'bidding_status',
        minWidth: 120,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'RFQ #',
        field: 'rfq_no',
        minWidth: 120,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'RFQ Status',
        field: 'rfq_status',
        minWidth: 120,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'PO #',
        field: 'purchase_order_no',
        minWidth: 120,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'PO Status',
        field: 'purchase_order_status',
        minWidth: 120,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'Line Item',
        field: 'item_count',
        minWidth: 90,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'Requisition Name',
        field: 'requisition_name',
        minWidth: 150,
        filter: false,
        hide: true,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'Bid Name',
        field: 'bidding_name',
        minWidth: 150,
        filter: false,
        hide: true,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'RFQ Name',
        field: 'rfq_name',
        minWidth: 150,
        filter: false,
        hide: true,
        flex: 1,
        resizable: true,
        sortable: false
    },
    {
        headerName: 'PO Name',
        field: 'purchase_order_name',
        minWidth: 150,
        filter: false,
        hide: true,
        flex: 1,
        resizable: true,
        sortable: false
    },
];

export const GroupColDef = [{
    headerName: 'Category',
    field: 'category_name',
    minWidth: 180,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Sub Category',
    field: 'sub_category',
    minWidth: 180,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Description',
    field: 'description',
    minWidth: 180,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Numeric ID',
    field: 'bixpand_id',
    minWidth: 180,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Alphanumeric ID',
    field: 'cad_id',
    minWidth: 180,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Total Items',
    field: 'total_items',
    minWidth: 180,
    filter: false,
    resizable: true,
    sortable: false
}];

export const ModelColDef = [{
    headerName: 'Model',
    field: 'model',
    minWidth: 180,
    flex: 1,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Category',
    field: 'category_name',
    minWidth: 180,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Sub Category',
    field: 'sub_category',
    minWidth: 180,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Total Items',
    field: 'total_items',
    minWidth: 80,
    filter: false,
    resizable: true,
    sortable: false
}];

export const MfgColDef = [{
    headerName: 'Manufacturer',
    field: 'manufacturer_name',
    minWidth: 180,
    flex: 1,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Total Items',
    field: 'total_items',
    minWidth: 80,
    filter: false,
    resizable: true,
    sortable: false
}];

export const VendorColDef = [{
    headerName: 'Vendor',
    field: 'vendor_name',
    minWidth: 180,
    flex: 1,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Total Items',
    field: 'total_items',
    minWidth: 80,
    filter: false,
    resizable: true,
    sortable: false
}];

export const InvoiceColumnDefs = [{
    field: '',
    checkboxSelection: true,
    resizable: false,
    sortable: false,
    width: 50
}, {
    headerName: 'Invoice Id',
    field: 'po_invoice_id',
    minWidth: 180,
    flex: 1,
    hide: true,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Actions',
    field: 'action',
    minWidth: 80,
    width: 80,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Attachment',
    field: 'attachment',
    minWidth: 80,
    width: 105,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Invoice #',
    field: 'invoice_no',
    minWidth: 80,
    width: 100,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Invoice Status',
    field: 'status',
    minWidth: 80,
    width: 100,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Invoice Date',
    field: 'invoice_date',
    minWidth: 80,
    width: 100,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Due Date',
    field: 'due_date',
    minWidth: 80,
    width: 100,
    filter: false,
    resizable: true,
    sortable: false
}, {
    headerName: 'Invoice Total',
    field: 'invoice_total',
    minWidth: 80,
    width: 100,
    filter: false,
    resizable: true,
    sortable: false,
    enableValue: true
}, {
    headerName: 'Item Total',
    field: 'sub_total',
    minWidth: 80,
    width: 100,
    filter: false,
    resizable: true,
    sortable: false,
    enableValue: true
}, {
    headerName: 'Tax',
    field: 'tax',
    minWidth: 80,
    filter: false,
    width: 100,
    resizable: true,
    sortable: false,
    enableValue: true
}, {
    headerName: 'Freight',
    field: 'freight',
    minWidth: 80,
    filter: false,
    width: 100,
    resizable: true,
    sortable: false,
    enableValue: true
}, {
    headerName: 'Storage',
    field: 'storage',
    minWidth: 80,
    filter: false,
    width: 100,
    resizable: true,
    sortable: false,
    enableValue: true
}, {
    headerName: 'Installation',
    field: 'installation',
    minWidth: 80,
    width: 100,
    filter: false,
    resizable: true,
    sortable: false,
    enableValue: true
}, {
    headerName: 'Fees',
    field: 'fees',
    minWidth: 80,
    filter: false,
    resizable: true,
    width: 100,
    sortable: false,
    enableValue: true
}, {
    headerName: 'Discounts',
    field: 'discounts',
    minWidth: 80,
    filter: false,
    width: 100,
    resizable: true,
    sortable: false,
    enableValue: true
}, {
    headerName: 'Trade In',
    field: 'tradein',
    minWidth: 80,
    width: 100,
    filter: false,
    resizable: true,
    sortable: false,
    enableValue: true
}];